import { OrganizationUserEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const OrganizationAccountResource = authResource({
    path: '/organizations/:organizationId/accounts/:userId?',
    searchParams: {},
    schema: OrganizationUserEntity
}).extend('getList', {
    schema: paginatedSchema(OrganizationUserEntity)
});
